import React from 'react'
import fireEvent from 'react-app-events/lib/fireEvent'
import Button from '@components/Button'
import PromotionTag from '@components/PromotionTag'
import productRequiredModifiers from '@helpers/misc/productWithRequiredModifiers'
import selectPriceForProduct from '@helpers/misc/selectPriceForProduct'
import FormatNumber from '@i18n/formatNumber/Component'
import PRICING_TYPES from '@page-components/Order/CategoryPage/Content/Products/ProductCard/pricingTypes'
import useAdd from '@page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd'
import Link from 'next/link'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'
import InformativeStamps from 'src/components/InformativeStamps'

import styles from './styles.module.css'

export default function RowProduct(props) {
  const router = useRouter()
  const {
    image,
    product,
    description,
    onClick,
    menuId,
    fastAddToCart = false,
    hidePrice,
    reverse,
    href
  } = props
  const {isOutOfStock, name, images} = product
  const add = useAdd()
  const requiredModifiers = productRequiredModifiers(product)
  const pricing = selectPriceForProduct(product)
  const {t} = useTranslation('website', {
    keyPrefix: 'order.products.productsContent.category.product.cards.rowProduct'
  })
  const buttonKeyLabel = isOutOfStock ? 'labelOutOfStock' : 'labelAddProduct'
  const informativeStampsList = product?.informativeStamps?.slice(0, 3)
  return (
    <div
      className={`${styles.container} ${isOutOfStock ? styles.containerOutOfStock : null} ${
        reverse ? styles.reverse : null
      }`}>
      {images && images.length > 0 ? (
        <div className={styles.image}>
          <Link href={href} scroll={false}>
            <a onClick={onClick}>{image}</a>
          </Link>
        </div>
      ) : null}
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <Link href={href} scroll={false}>
            <a onClick={onClick}>
              <div className={styles.name}>{name}</div>
              <InformativeStamps stamps={informativeStampsList} iconOnly={true} />
              <div className={styles.description}>{description}</div>
            </a>
          </Link>
        </div>
        <div className={styles.priceContainer}>
          {pricing && !hidePrice ? (
            <div>
              <Link href={href} scroll={false}>
                <a className={styles.price} onClick={onClick}>
                  {pricing.type === PRICING_TYPES.normal && <FormatNumber value={pricing.price} />}
                  {pricing.type === PRICING_TYPES.discount && (
                    <>
                      <FormatNumber value={pricing.price} />
                      <span>
                        <FormatNumber value={pricing.oldPrice} />
                      </span>
                    </>
                  )}
                  {pricing.type === PRICING_TYPES.notAvailable && pricing.message}
                  {pricing.type === PRICING_TYPES.promotions && <PromotionTag product={product} />}
                </a>
              </Link>
            </div>
          ) : null}
          <Button
            primary
            onClick={async () => {
              if (hidePrice) {
                fireEvent('hiddenPriceProductOpened', product)
                return null
              }
              if (isOutOfStock) return null
              if (requiredModifiers || !fastAddToCart) {
                onClick()
                router.push(href, href, {scroll: false})
              } else {
                await add(
                  {
                    ...props,
                    close: () => {
                      // avoid error on add to cart
                    },
                    menuId: menuId
                  },
                  {amount: 1, modifiers: [], comment: ''},
                  product,
                  {
                    missingModifier: false
                  }
                )
              }
            }}
            disabled={isOutOfStock}>
            {t(buttonKeyLabel)}
          </Button>
        </div>
      </div>
    </div>
  )
}
